import { PaymentGatewayCard } from "./card"
import razorpayLogo from "@/assets/razorpay.png"
import easebuzzLogo from "@/assets/easebuzz.png"
import useGateways from "./use-gateways"
import type { PaymentGatewayDetails } from "@/types/form-types"
import { logger } from "@/utils/logger"

const RazorpayIcon = () => (
	<div className="flex h-10 w-10 items-center justify-center">
		<img
			src={razorpayLogo}
			alt="Razorpay"
			className="h-8 w-8 object-contain"
		/>
	</div>
)

const EasebuzzIcon = () => (
	<div className="flex h-10 w-10 items-center justify-center">
		<img
			src={easebuzzLogo}
			alt="Easebuzz"
			className="h-8 w-8 object-contain"
		/>
	</div>
)

// export interface PaymentGateway {
//   id: string;
//   name: string;
//   variant: "RAZORPAY" | "EASEBUZZ" | "EDVIRON";
//   icon: React.ReactNode;
//   description?: string;
//   isActive: boolean;
// }

export interface PaymentGatewaysProps {
	onSelect: (gatewayId: string) => void
	batchId: string
	partnerId: string
	showPaymentGateway: boolean
}

export const PaymentGateways = ({
	onSelect,
	batchId,
	partnerId,
	showPaymentGateway,
}: PaymentGatewaysProps) => {
	const { useGetPaymentGateways } = useGateways()

	const { data: availableGateways = [] } = useGetPaymentGateways({
		batchId,
		partnerId,
	})

	//use the availableGateways to map the payment gateways
	const paymentGateways: PaymentGatewayDetails[] = availableGateways || []

	const handleGatewaySelect = (gatewayId: string) => {
		if (!showPaymentGateway) return
		onSelect(gatewayId) // trigger payment
	}

	const getGatewayIcon = (gateway: string) => {
		switch (gateway) {
			case "RAZORPAY":
				return <RazorpayIcon />
			case "EASEBUZZ":
				return <EasebuzzIcon />
			case "EDVIRON":
				return <>EDVIRON</>
			default:
				return <></>
		}
	}

	if (paymentGateways.length === 0) {
		logger.info("No Payment Gateways Available")
		return (
			<div className="bg-muted/20 space-y-4 rounded-lg border p-4">
				<h3 className="text-destructive text-lg font-semibold">
					No Payment Gateways Available
				</h3>
				<p className="text-muted-foreground text-sm">
					No payment gateways are configured for this batch and
					partner. Please contact support for assistance or try again
					later.
				</p>
			</div>
		)
	}

	return (
		<div className="space-y-4">
			<h3 className="mt-4 text-lg font-semibold">
				Select Payment Gateway
			</h3>
			{paymentGateways.map(gatewayDetails => {
				const shouldDisable = !showPaymentGateway
				return (
					<div
						key={gatewayDetails.gateway}
						className="group"
					>
						<PaymentGatewayCard
							icon={getGatewayIcon(gatewayDetails.gateway)}
							name={gatewayDetails.gateway}
							variant={
								gatewayDetails.gateway as
									| "RAZORPAY"
									| "EASEBUZZ"
									| "EDVIRON"
							}
							disabled={shouldDisable}
							onClick={() =>
								handleGatewaySelect(gatewayDetails.gateway)
							}
						/>
					</div>
				)
			})}
			{paymentGateways.length > 0 && (
				<p className="text-muted-foreground mt-4 text-center text-sm">
					More payment options coming soon
				</p>
			)}
		</div>
	)
}
